<div class="container my-5 mx-0 px-0">
  <div class="demand text-center  d-flex px-3 align-items-center">Customer Demand Mapping Form</div>
  <!-- <div class="m-5">
    <div class=" m-5 menu">
      <ul  class="d-flex justify-content-between" style="list-style: none;">
        <li class="d-flex">
          <button class="rounded-circle" [ngClass]="(this.CustomerDemand.status=='VALID')? 'qualli' : 'not-touched' " id='customer_info' (click)="FormIsAt('customer_info')">
            1
          </button>
        </li>
        <hr [ngClass]="(this.CustomerDemand.status=='VALID') ? 'filled': 'notfilled' ">
        <li>
          <button class="rounded-circle" [disabled]="this.CustomerDemand.status=='INVALID'" [ngClass]="(this.touched) ? 'touched': 'not-touched' " id='master_bedroom'   (click)="FormIsAt('master_bedroom')">2</button>
        </li>
        <hr [ngClass]="(this.touched) ? 'filled': 'notfilled' " >
        <li>
          <button class="rounded-circle" [disabled]="this.CustomerDemand.status=='INVALID'" [ngClass]="(this.parents) ? 'touched': 'not-touched' "  id='parents_room'  (click)="FormIsAt('parents_room')">3</button>
        </li>
        <hr [ngClass]="(this.parents) ? 'filled': 'notfilled' ">
        <li>
          <button class="rounded-circle" [disabled]="this.CustomerDemand.status=='INVALID'" [ngClass]="(this.kids) ? 'touched': 'not-touched' "  id='kids_bedroom'  (click)="FormIsAt('kids_bedroom')">4</button>
        </li>
        <hr [ngClass]="(this.kids) ? 'filled': 'notfilled' ">
        <li>
          <button class="rounded-circle" [disabled]="this.CustomerDemand.status=='INVALID'" [ngClass]="(this.living) ? 'touched': 'not-touched' "  id='living_room'   (click)="FormIsAt('living_room')">5</button>
        </li>
        <hr [ngClass]="(this.living) ? 'filled': 'notfilled' ">
        <li>
          <button class="rounded-circle" [disabled]="this.CustomerDemand.status=='INVALID'" [ngClass]="(this.kitchen) ? 'touched': 'not-touched' "  id='kitchen'   (click)="FormIsAt('kitchen')">6</button>
        </li>
      </ul>
    </div>
  </div> -->
   <div class="">
      <ul class="row  nav m-0">
        <li class="col-2 px-1 nav-item"><button class="tabs-button "  [ngClass]="(this.CustomerDemand.status=='VALID')? 'qualified' : 'notfilled' "  id='customer_info' (click)="FormIsAt('customer_info')">Customer Information </button> </li>
        <li class="col-2 px-1 nav-item"><button class="tabs-button "   [disabled]="this.CustomerDemand.status=='INVALID'" [ngClass]="(this.touched) ? 'drafted': 'notfilled' " id='master_bedroom'   (click)="FormIsAt('master_bedroom')">Master Bedroom </button></li>
        <li class="col-2 px-1 nav-item"><button class="tabs-button "   [disabled]="this.CustomerDemand.status=='INVALID'"  [ngClass]="(this.parents) ? 'drafted': 'notfilled' "  id='parents_room'  (click)="FormIsAt('parents_room')">Parents Bedroom </button></li>
        <li class="col-2 px-1 nav-item"><button class="tabs-button "   [disabled]="this.CustomerDemand.status=='INVALID'"  [ngClass]="(this.kids) ? 'drafted': 'notfilled' "  id='kids_bedroom'  (click)="FormIsAt('kids_bedroom')">Kids Bedroom </button></li>
        <li class="col-2 px-1 nav-item"><button class="tabs-button "   [disabled]="this.CustomerDemand.status=='INVALID'"  [ngClass]="(this.living) ? 'drafted': 'notfilled' "id='living_room' (click)="FormIsAt('living_room')">Living Room </button></li>
        <li class="col-2 px-1 nav-item"><button class="tabs-button "   [disabled]="this.CustomerDemand.status=='INVALID'"  [ngClass]="(this.kitchen) ? 'drafted': 'notfilled' " id='kitchen' (click)="FormIsAt('kitchen')">Kitchen </button></li>
      
      </ul>
    </div>
    <!-- <div class="col-3">
      <ul class="nav nav-tabs flex-column">
        <li class="nav-item"><button class="tabs-button "  [ngClass]="(this.CustomerDemand.status=='VALID')? 'qualified' : 'notfilled' "  id='customer_info' (click)="FormIsAt('customer_info')">Customer Information</button> </li>
        <li class="nav-item"><button class="tabs-button "   [disabled]="this.CustomerDemand.status=='INVALID'" [ngClass]="(this.touched) ? 'drafted': 'notfilled' " id='master_bedroom'   (click)="FormIsAt('master_bedroom')">Master Bedroom      </button></li>
        <li class="nav-item"><button class="tabs-button "   [disabled]="this.CustomerDemand.status=='INVALID'"  [ngClass]="(this.parents) ? 'drafted': 'notfilled' "  id='parents_room'  (click)="FormIsAt('parents_room')">Parents Bedroom     </button></li>
        <li class="nav-item"><button class="tabs-button "   [disabled]="this.CustomerDemand.status=='INVALID'"  [ngClass]="(this.kids) ? 'drafted': 'notfilled' "  id='kids_bedroom'  (click)="FormIsAt('kids_bedroom')">Kids Bedroom        </button></li>
        <li class="nav-item"><button class="tabs-button "   [disabled]="this.CustomerDemand.status=='INVALID'"  [ngClass]="(this.living) ? 'drafted': 'notfilled' "id='living_room' (click)="FormIsAt('living_room')">Living Room         </button></li>
        <li class="nav-item"><button class="tabs-button "   [disabled]="this.CustomerDemand.status=='INVALID'"  [ngClass]="(this.kitchen) ? 'drafted': 'notfilled' " id='kitchen' (click)="FormIsAt('kitchen')">Kitchen             </button></li>
      
      </ul>
    </div>-->
    
      <div class="formBlock">
        <form [formGroup]="CustomerDemand" >

          <div class="row" *ngIf="this.selectedtab=='customer_info'">

            <!-- <div  formGroupName="customerInformation" > -->
              <div class=" col-md-12 header my-2 d-flex justify-content-between">
                <span>Customer Information</span>
                <!-- <span> <i class="fas fa-edit"></i></span> -->
              </div>
<!-- customer_name -->
              <div class="col-md-6 mt-4">
                  <label class="customLabel">Customer Name<span class="astric">*</span></label>
                  <input type="text" class="form-control " formControlName="customer_name" placeholder="">
              </div>
<!-- property_name -->
              <div class="col-md-6 mt-4">
                  <label class="customLabel">Property Name<span class="astric">*</span></label>
                  <input type="text" class="form-control" formControlName="property_name" placeholder="">
              </div>
<!-- Accomdation -->
              <div class="col-md-6 type-data form-check w-100 mt-3">
                  <label class="customLabel">Accommodation<span class="astric">*</span></label>
                  <div class="">
                    <div class="form-group">
                      <input type="radio" class="form-check-input ml-3" id="1bhk" value="1BHK" formControlName="accommodation">
                      <label class="form-check-label pl-5 pr-4" >1 BHK</label>
                    </div>
                    <div class="form-group">
                      <input type="radio" class="form-check-input ml-3" id="2bhk" value="2BHK" formControlName="accommodation">
                      <label class="form-check-label pl-5 pr-4" >2 BHK</label>
                    </div>
                    <div class="form-group">
                      <input type="radio" class="form-check-input ml-3" id="3bhk" value="3BHK" formControlName="accommodation">
                      <label class="form-check-label pl-5 pr-4">3 BHK</label>
                    </div>
                    <div class="form-group">
                      <input type="radio" class="form-check-input ml-3" id="Other" value="Other" formControlName="accommodation" (click)="OtherAccomadation()">
                      <label class="form-check-label pl-5 pr-4" >Other</label>
                      <input type="text"  *ngIf="this.CustomerDemand.value.accommodation=='Other' " formControlName="other_accommodation">
                    </div>
                  </div>
              </div> 
<!-- carpet_area -->
              <div class="col-md-6 mt-4">
                  <label class="customLabel">Carpet Area (Sq.Ft.)</label>
                  <input type="text" class="form-control " formControlName="carpet_area" placeholder="">
              </div>

              <div class="col-md-12 header mt-2">Lifestyle & Life Stage Needs</div>
<!-- family_details -->
              <div class="col-md-12 mt-4">
                <label class="customLabel">Please give us a brief description of your family. (Include all members of your household)</label><span class="astric">*</span> 
                <textarea  class="form-control " style="width:calc(45%)" rows="4" cols="100" formControlName="family_details" placeholder=""></textarea>
              </div>
<!-- house_help -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Do you have a 24x7 house help<span class="astric">*</span></label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="house_help">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="house_help">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- Vastu -->
              <div class="col-md-6 type-data form-check  w-100 ml-0 mt-3">
                <label class="customLabel">Do you want your house as per Vastu<span class="astric">*</span></label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"   [value]="true" formControlName="house_vastu">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="house_vastu">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- kind_of_gatherings -->             
              <div class="col-md-12 d-flex flex-column mt-3">
                <label class="customLabel">What kind of gatherings do you hold</label>
                <label class="ml-2 d-flex" formArrayName="gathering_type" *ngFor="let order of gatherings; let i = index" >
                  <input type="checkbox" [checked]="this.checked.includes(order.name)" [value]="order.name" (change)="onCheckboxChange($event,'gathering_type')">
                  &nbsp; {{order.id}} 
                </label>
              </div>
<!-- hobbies -->             
              <div class="col-md-12 d-flex flex-column mt-3">
                <label class="customLabel">What are the things you enjoy to do as a hobby or activity with family</label>
                <label class="ml-2 d-flex" formArrayName="hobby_with_family" *ngFor="let order of familyhobbies; let i = index" >
                  <input type="checkbox" [checked]="this.hobbies.includes(order.name)" [value]="order.name" (change)="onCheckboxChange($event,'hobby_with_family')">
                  &nbsp; {{order.id}} 
                </label>
                
                <input type="text" class="form-control" *ngIf="this.hobbies.includes('Other')" formControlName="other_hobby" >


              </div>
<!-- pets -->
              <div class="col-md-6 type-data form-check w-100 mt-3">
                <label class="customLabel">Do you have any pets<span class="astric">*</span></label>
                <div class="d-flex">
                  <div class="form-group d-flex">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="pets">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group d-flex">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="pets">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- special_needs -->
              <div class="col-md-6 mt-4" *ngIf="this.CustomerDemand.value.pets">
                  <label class="customLabel">Any special needs for pets</label>
                  <input type="text" class="form-control" formControlName="need_pet" placeholder="">
              </div>

              <div class="col-md-12 header mt-2">Colour Preferences</div>
<!-- clours -->
              <div class="col-md-6 d-flex flex-column mt-3">
                <label class="customLabel">What colours you prefer in your house<span class="astric">*</span></label>
                <label class="ml-2 d-flex" formArrayName="house_colour" *ngFor="let order of colours; let i = index" >
                  <input type="checkbox" [checked]="this.colurs.includes(order.name)" [value]="order.name" (change)="onCheckboxChange($event,'house_colour')">
                  &nbsp; {{order.id}} 
                </label>
                
                <input type="text" class="form-control" *ngIf="this.colurs.includes('Other')" formControlName="other_colour" >

              </div>             
<!-- colours_you_dislike -->
              <div class="col-md-6 mt-4">
                <label class="customLabel">Which colours you dislike</label>
                <input type="text" class="form-control" formControlName="colours_dislike" placeholder="">
              </div>
<!-- fabric -->
              <div class="col-md-6 d-flex flex-column mt-3">
                <label class="customLabel">Do you have any preferences of fabric </label>
                <label class="ml-2 d-flex" formArrayName="fabric_preference" *ngFor="let order of fabric_preference; let i = index" >
                  <input type="checkbox"  [checked]="this.fabric.includes(order.name)" [value]="order.name" (change)="onCheckboxChange($event,'fabric_preference')">
                  &nbsp; {{order.id}} 
                </label>
                
                <input type="text" class="form-control" *ngIf="this.fabric.includes('Other')" formControlName="other_fabric" >

              </div>            
<!-- patterns -->
              <div class="col-md-6 d-flex flex-column mt-3">
                <label class="customLabel">Do you prefer any patterns</label>
                <label class="ml-2 d-flex" formArrayName="fabric_prefer_pattern" *ngFor="let order of fabric_prefer_pattern; let i = index" (change)="onCheckboxChange($event,'fabric_prefer_pattern')">
                  <input type="checkbox" [checked]="this.pattern.includes(order.name)" [value]="order.name" >
                  &nbsp; {{order.id}} 
                </label>
                
                <input type="text" class="form-control" *ngIf="this.pattern.includes('Other')" formControlName="other_pattern" >

              </div>            
<!-- existing_furniture -->
              <div class="col-md-6 mt-4">
                <label class="customLabel">Are there any existing furniture or decor items you want to keep</label>
                <input type="text" class="form-control" formControlName="existing_furniture" placeholder="">
              </div>

              <div class="col-md-12 header mt-2">Education on Materials & Budget Impact</div>
<!-- core_material -->
              <div class="col-md-6 d-flex flex-column mt-4">
                <label class="customLabel">Core material</label>
                <label class="ml-2 d-flex" formArrayName="core_material" *ngFor="let order of core_material; let i = index" (change)="onCheckboxChange($event,'core_material')">
                  <input type="checkbox" [checked]="this.core.includes(order.name)" [value]="order.name" >
                  &nbsp; {{order.id}} 
                </label>
                
              </div> 
<!-- finish_material -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Finish Material</label>
                <div class="">
                  <div class="form-group d-flex">
                    <input type="radio" class="form-check-input ml-3"  value="Entry_Level_Laminates" formControlName="finish_material">
                    <label class="form-check-label pl-5 pr-4" >Entry Level Laminates </label>
                  </div>
                  <div class="form-group d-flex">
                    <input type="radio" class="form-check-input ml-3"  value="Premium_Range" formControlName="finish_material">
                    <label class="form-check-label pl-5 pr-4" >Premium Range</label>
                  </div>
                  <div class="form-group d-flex">
                    <input type="radio" class="form-check-input ml-3"  value="PU" formControlName="finish_material">
                    <label class="form-check-label pl-5 pr-4" >PU</label>
                  </div>
                </div>
              </div>
<!-- finish_choice -->
              <div class="col-md-6 mt-4">
                <label class="customLabel">Estimate as per material and finish choice </label>
                <input type="text" class="form-control" formControlName="estimate" placeholder="">
              </div>

              <div class="col-md-12 header mt-2">Theme Preference</div>
<!-- theme_preference -->
              <div class="col-md-6 d-flex flex-column mt-3">
                <label class="customLabel">Which is your preferred theme</label>
                <label class=" ml-2 d-flex" formArrayName="preferred_theme" *ngFor="let order of preferredtheme; let i = index" >
                  <input type="checkbox" [checked]="this.theme.includes(order.name)" [value]="order.name" (change)="onCheckboxChange($event,'preferred_theme')">
                  &nbsp; {{order.id}} 
                </label>
              </div>
          
            <div class="col-md-12 m-0 d-flex justify-content-between m-0 px-5 pt-3">
              <button class="save btn btn-pink" (click)="saveasdraft()">Save as draft</button>
              <button class="next btn btn-pink" (click)="gotonext()" 
                [disabled]="this.CustomerDemand.status=='INVALID'">
                Next
              </button>
            </div>

          </div>
 <!-- MasterBedroom -->
          <div class="row" *ngIf="this.selectedtab=='master_bedroom'">

            <!-- <div  formGroupName="Master_Bedroom" > -->
            
              <div class="header col-md-12  my-2  d-flex justify-content-between">
                <span>Requirements for Master Bedroom - Wardrobes</span>
                <!-- <span> <i class="fas fa-edit"></i></span> -->
              </div>

              <!-- <div class="header col-md-12 ">Wardrobes</div> -->
<!-- wardrobe-type -->
              <div class="col-md-6 d-flex flex-column form-check  mt-3">
                <label class="customLabel">What kind of wardrobe you are looking for</label>
                <label class="ml-2 d-flex" formArrayName="wardrobe_type" *ngFor="let order of wardrobe_type; let i = index" >
                  <input type="checkbox" [checked]="this.wardtype.includes(order.name)" [value]="order.name" (change)="onCheckboxChange($event,'wardrobe_type')">
                  &nbsp; {{order.id}} 
                </label>
              </div>             
<!-- addLocks -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Do you need to add locks to wardrobe drawers</label>
                <div class="d-flex">
                  <div class="form-group d-flex">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="lock_wardrobe">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group d-flex">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="lock_wardrobe">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- standardWardrobe -->
              <div class="col-md-6 type-data form-check w-100 mt-3">
                <label class="customLabel">Our standard wardrobes 3ft wardrobe has 2 drawers with locks, 1 hanging rod and 2 shelves down</label>
                <div class="d-flex">
                  <div class="form-group d-flex">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="standard_wardrobe">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group d-flex">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="standard_wardrobe">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- premiumVersion -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">We have a premium version of the same where cost varies as per specifications</label>
                <div class="d-flex">
                  <div class="form-group d-flex">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="preminum_version">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group d-flex">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="preminum_version">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- Preference -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Preference,  folded clothes or hung clothes</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Folder" formControlName="prefer_clothes">
                    <label class="form-check-label pl-5 pr-4" >Folder</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Hung" formControlName="prefer_clothes">
                    <label class="form-check-label pl-5 pr-4" >Hung</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Both" formControlName="prefer_clothes">
                    <label class="form-check-label pl-5 pr-4" >Both</label>
                  </div>
                </div>
              </div>
<!-- jewelleryArea -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Do you need a separate bag and jewellery area</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="jewellery_area">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="jewellery_area">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- largeItems -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Any safes / luggage, or other large items</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="safes">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="safes">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>

              <div class="header col-md-12 mt-2">Beds</div>
<!-- preferedBeds -->
              <div class="col-md-6 type-data form-check w-100 mt-3">
                <label class="customLabel">Preferred bed</label>
                <div class="">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Upholstered_Bed" formControlName="preferred_bed">
                    <label class="form-check-label pl-5 pr-4" >Upholstered Bed</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Wooden_Headboard_Bed" formControlName="preferred_bed">
                    <label class="form-check-label pl-5 pr-4" >Wooden Headboard Bed</label>
                  </div>
                </div>
              </div>
<!-- hydraulicStorage -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Our beds have hydraulic storage, do you need drawers for storage</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="drawer_storage">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="drawer_storage">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- children -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Do children sleep with you</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="children_sleep_u">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="children_sleep_u">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- existingMattress -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Do you have an existing mattress</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="existing_mattress">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="existing_mattress">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- SizeOfMatteress -->
              <div class="col-md-6 mt-4">
                <label class="customLabel">If yes, what is the size of the mattress</label>
                <input type="text" class="form-control" formControlName="size_matters" placeholder="">
              </div>
<!-- typeOfmatteress -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">If no, at mattress would you prefer</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="hard" formControlName="prefer_matters">
                    <label class="form-check-label pl-5 pr-4" >Hard</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="soft" formControlName="prefer_matters">
                    <label class="form-check-label pl-5 pr-4" >Soft</label>
                  </div>
                </div>
              </div>
<!-- nightStands -->
              <div class="col-md-6 type-data form-check w-100 mt-3">
                <label class="customLabel">Do you need night stands</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="night_stands">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="night_stands">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>

              <div class="header col-md-12 mt-2">Dressers</div>
<!-- inconvenience -->
              <div class="col-md-6 mt-4">
                <label class="customLabel">Is there any inconvenience in using for your current dressing table</label>
                <input type="text" class="form-control" formControlName="inconvenience_dressing_table" placeholder="">
              </div>
<!-- separateDressingTable -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Do you need a separate dressing table </label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="need_dressing_table">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="need_dressing_table">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
            
              <div class="header col-md-12 mt-2">  TV & AC</div>
<!--  TVInBedroom -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Is there a TV in bedroom </label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="tv_in_bedroom">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="tv_in_bedroom">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- bayWindow -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Do you want to make use of bay window</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="bay_window">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="bay_window">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- positionAirconditioner -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Have you decided the position of air conditioner</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="position_air_conditioner">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="position_air_conditioner">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>

              <div class="header col-md-12 mt-2">Study</div>
<!-- studyRequirments -->
              <div class="col-md-6 mt-4">
                <label class="customLabel">Check location wise study requirement in master bedroom</label>
                <input type="text" class="form-control" formControlName="requirement_master_bedroom" placeholder="">
              </div>

              <div class="header col-md-12 mt-2">Budget for the room</div>
<!-- core_material -->
              <div class="col-md-6 d-flex flex-column mt-4">
                <label class="customLabel">Core material</label>
                <div class="">
                  <div class="form-group">
                    <input class="form-check-input ml-3 " type="radio" formControlName="core_material_master_bedroom"  value="MDF" >
                    <label class="form-check-label pl-5 pr-4 " >MDF</label>
                  </div>
                  <div class="form-group">
                    <input class="form-check-input ml-3 " type="radio" formControlName="core_material_master_bedroom" value="HDHMR" >
                    <label class="form-check-label pl-5 pr-4" >HDHMR</label>
                  </div>
                  <div class="form-group">
                    <input class="form-check-input ml-3 " type="radio" formControlName="core_material_master_bedroom"  value="Ply" >
                    <label class="form-check-label pl-5 pr-4 ">Ply</label>
                  </div>
                </div>
              </div> 
<!-- finish_material -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Finish Material</label>
                <div class="">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Entry_Level_Laminates" formControlName="finish_material_master_bedroom">
                    <label class="form-check-label pl-5 pr-4" >Entry Level Laminates </label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Premium_Range" formControlName="finish_material_master_bedroom">
                    <label class="form-check-label pl-5 pr-4" >Premium Range</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="PU" formControlName="finish_material_master_bedroom">
                    <label class="form-check-label pl-5 pr-4" >PU</label>
                  </div>
                </div>
              </div>
<!-- finish_choice -->
              <div class="col-md-6 mt-4">
                <label class="customLabel">Estimate as per material and finish choice</label>
                <input type="text" class="form-control " formControlName="estimate_master_bedroom" placeholder="">
              </div>          

            <div class="header col-md-12  mt-2">Services</div>
<!-- servicesRequire -->
              <div class="col-md-6 d-flex flex-column mt-3">
                <label class="customLabel">What services would you require in this room</label>
                <label class="ml-2 d-flex" formArrayName="services_require" *ngFor="let order of services_require; let i = index" >
                  <input type="checkbox" [checked]="this.service.includes(order.name)" [value]="order.name"(change)="onCheckboxChange($event,'services_require')" >
                  &nbsp; {{order.id}} 
                </label>
              </div>
            <div class="col-md-12  d-flex justify-content-between m-0 px-5 pt-3">
              <button class="save btn btn-pink" (click)="saveasdraft()">Save as draft</button>
              <button class="next btn btn-pink" (click)="gotonext()">Next</button>
            </div>
          </div>
 <!-- parents_room -->
          <div class="row" *ngIf="this.selectedtab=='parents_room'">

            <div class="header col-md-12  my-2  d-flex justify-content-between">
              <span>Requirements for Parents Bedroom - Wardrobes</span>
              <!-- <span> <i class="fas fa-edit"></i></span> -->
            </div>

            <!-- <div  formGroupName="Parents_Bedroom" > -->
              <!-- <div class="header col-md-12 ">Wardrobes</div> -->
<!-- kind_of_wardrobe -->
              <div class="col-md-6 d-flex flex-column mt-3">
                <label class="customLabel">What kind of wardrobe you are looking for</label>
                <label class="ml-2 d-flex" formArrayName="wardrobe_parent" *ngFor="let order of wardrobe_parent; let i = index" >
                  <input type="checkbox" [checked]="this.wardrobeParent.includes(order.name)" [value]="order.name" (change)="onCheckboxChange($event,'wardrobe_parent')">
                  &nbsp; {{order.id}} 
                </label>
              </div>  
<!-- addLocks -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Do you need to add locks to wardrobe drawers</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="lock_wardrobe_parent">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="lock_wardrobe_parent">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- standardWardrobe -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Our standard wardrobes 3ft wardrobe has 2 drawers with locks, 1 hanging rod and 2 shelves down</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="std_wardrobe_parent">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="std_wardrobe_parent">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- premiumVersion -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">We have a premium version of the same where cost varies as per specifications</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="preminum_version_parent">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="preminum_version_parent">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- Preference -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Any safes / luggage, or other large items</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="safes_parent">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="safes_parent">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                  
                </div>
              </div>

              <div class="header col-md-12 mt-2">Beds</div>
<!-- bedHeight -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Preferred bed height</label>
                <div class="
                ">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Low_Bed" formControlName="bed_height">
                    <label class="form-check-label pl-5 pr-4" >Low Bed</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Standard_Height_Bed" formControlName="bed_height">
                    <label class="form-check-label pl-5 pr-4" >Standard Height Bed</label>
                  </div>
                </div>
              </div>

              <div class="header col-md-12 mt-2">  TV & AC</div>
<!--  TVInBedroom -->
              <div class="col-md-6 type-data form-check w-100 mt-3">
                <label class="customLabel">Is there a TV in bedroom </label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="tv_in_bedroom_parent">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="tv_in_bedroom_parent">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- positionAirconditioner -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Have you decided the position of air conditioner</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="position_air_conditioner_parent">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="position_air_conditioner_parent">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>

              <div class="header col-md-12  mt-2">Budget for the room</div>
<!-- core_material -->
              <div class="col-md-6 d-flex flex-column mt-4">
                <label class="customLabel">Core material</label>
                <div class="">
                  <div class="form-group">
                    <input class="form-check-input ml-3 " type="radio" formControlName="core_material_parent"  value="MDF" >
                    <label class="form-check-label pl-5 pr-4 " >MDF</label>
                  </div>
                  <div class="form-group">
                    <input class="form-check-input ml-3 " type="radio" formControlName="core_material_parent" value="HDHMR" >
                    <label class="form-check-label pl-5 pr-4" >HDHMR</label>
                  </div>
                  <div class="form-group">
                    <input class="form-check-input ml-3 " type="radio" formControlName="core_material_parent"  value="Ply" >
                    <label class="form-check-label pl-5 pr-4 ">Ply</label>
                  </div>
                </div>
              </div> 
<!-- finish_material -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Finish Material</label>
                <div class="">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Entry_Level_Laminates" formControlName="finish_material_parent">
                    <label class="form-check-label pl-5 pr-4" >Entry Level Laminates </label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Premium_Range" formControlName="finish_material_parent">
                    <label class="form-check-label pl-5 pr-4" >Premium Range</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="PU" formControlName="finish_material_parent">
                    <label class="form-check-label pl-5 pr-4" >PU</label>
                  </div>
                </div>
              </div>
<!-- finish_choice -->
              <div class="col-md-6 mt-4">
                <label class="customLabel">Estimate as per material and finish choice </label>
                <input type="text" class="form-control" formControlName="estimate_parent" placeholder="">
              </div>
      
              <div class="header col-md-12  mt-2">Services</div>
<!-- servicesRequire -->
              <div class="col-md-6 d-flex flex-column mt-3">
                <label class="customLabel">What services would you require in this room</label>
                <label class="ml-2 d-flex" formArrayName="services_require_parent" *ngFor="let order of services_require; let i = index" >
                  <input type="checkbox" [checked]="this.serviceParent.includes(order.name)" [value]="order.name" (change)="onCheckboxChange($event,'services_require_parent')">
                  &nbsp; {{order.id}} 
                </label>
              </div>

             
              <div class="col-md-12  d-flex justify-content-between  m-0 px-5 pt-3">
                <button class="save btn btn-pink" (click)="saveasdraft()">Save as draft</button>
                <button class="next btn btn-pink" (click)="gotonext()">Next</button>
              </div>
          </div> 

 <!-- kids_bedroom -->
          <div class="row" *ngIf="this.selectedtab=='kids_bedroom'">

            <div class="header col-md-12  my-2  d-flex justify-content-between">
              <span>Requirements for Kids Bedroom - Wardrobes</span>
              <!-- <span> <i class="fas fa-edit"></i></span> -->
            </div>

            <!-- <div  formGroupName="Kids_Bedroom" > -->
            
              <!-- <div class="header col-md-12 ">Wardrobes</div> -->
<!-- storageBoxes -->
              <div class="col-md-6 type-data form-check w-100 mt-3">
                <label class="customLabel pr-5">Children's clothes are small size. Do you need storage boxes for clothes </label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="storage_box">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="storage_box">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>

<!-- walkInCloset -->
              <div class="col-md-6 type-data form-check w-100 mt-3">
                <label class="customLabel">Small space area but high storage requirements? Walk-in closet is recommended</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="storage_require">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="storage_require">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- preference -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Preference,  folded clothes or hung clothes</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Folder" formControlName="clothes_type">
                    <label class="form-check-label pl-5 pr-4" >Folder</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Hung" formControlName="clothes_type">
                    <label class="form-check-label pl-5 pr-4" >Hung</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Both" formControlName="clothes_type">
                    <label class="form-check-label pl-5 pr-4" >Both</label>
                  </div>
                </div>
              </div>
<!-- storageRequirments -->
              <div class="col-md-6 type-data form-check w-100 mt-3">
                <label class="customLabel">Small space area but high storage requirements</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="high_storage_require">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="high_storage_require">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- slidingOrRotating -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Sliding Wardrobe or Rotating Door</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Sliding Wardrobe" formControlName="wardrobe_kids">
                    <label class="form-check-label pl-5 pr-4" >Sliding Wardrobe</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Rotating Door" formControlName="wardrobe_kids">
                    <label class="form-check-label pl-5 pr-4" >Rotating Door</label>
                  </div>
                </div>
              </div>

              <div class="header col-md-12  mt-2">Beds</div>
<!-- typeOfBed -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Type of bed</label>
                <div class="">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Bunk Bed" formControlName="bed_type">
                    <label class="form-check-label pl-5 pr-4" >Bunk Bed</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Rotating Door" formControlName="bed_type">
                    <label class="form-check-label pl-5 pr-4" >Single Bed</label>
                  </div>
                </div>
              </div>
<!-- storageBed -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Do you need a storage bed? If yes, lift-up / drawer bed is recommended.</label>
                <div class="">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Lift-up Bed" formControlName="storage_bed_type">
                    <label class="form-check-label pl-5 pr-4" >Lift-up Bed</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Drawer Bed" formControlName="storage_bed_type">
                    <label class="form-check-label pl-5 pr-4" >Drawer Bed</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="No Storage Bed Required" formControlName="storage_bed_type">
                    <label class="form-check-label pl-5 pr-4" >No Storage Bed Required</label>
                  </div>
                </div>
              </div>

              <div class="header col-md-12  mt-2">Others</div>
<!-- bayWindow -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Do you want to make use of bay window</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="bay_window_kids">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="bay_window_kids">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- positionOfAirconditioner -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Have you decided the position of air conditioner</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="position_air_conditioner_kids">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="position_air_conditioner_kids">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>

              <div class="header col-md-12  mt-2">Study</div>
<!-- system -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Desktop or laptop</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Desktop" formControlName="desktop_or_laptop">
                    <label class="form-check-label pl-5 pr-4" >Desktop</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Laptop" formControlName="desktop_or_laptop">
                    <label class="form-check-label pl-5 pr-4" >Laptop</label>
                  </div>
                </div>
              </div>
<!-- Bookcase -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Are there a lot of books? Bookcase capacity consideration</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="lot_of_books">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="lot_of_books">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>

              <div class="header col-md-12  mt-2">Color Preference</div>
<!-- hobbies -->
              <div class="col-md-6 mt-4">
                <label class="customLabel">What are the childrens' hobbies </label>
                <input type="text" class="form-control " formControlName="children_hobbies" placeholder="">
              </div>

<!-- colorPreference -->
              <div class="col-md-6 mt-4">
                <label class="customLabel">Color preference</label>
                <input type="text" class="form-control " formControlName="colour_prefer" placeholder="">
              </div>

              <div class="header col-md-12  mt-2">Living Requirements</div>
<!-- otherRequirments -->
              <div class="col-md-6 mt-4">
                <label class="customLabel">Position of the bed / other special requirements</label>
                <input type="text" class="form-control " formControlName="position_bed" placeholder="">
              </div>
<!-- StorageForToys -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Do you need storage boxes for toys</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="boxes_toys">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="boxes_toys">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- wallpaper -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Any requirements for wallpaper, stickers etc</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="require_wallpaper">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="require_wallpaper">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- studyArea -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Specific study area for kids</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="study_area">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="study_area">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- activityArea -->
                <div class="col-md-6 type-data form-check  w-100 mt-3">
                  <label class="customLabel">Specific activity area for kids</label>
                  <div class="d-flex">
                    <div class="form-group">
                      <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="activity_area">
                      <label class="form-check-label pl-5 pr-4" >Yes</label>
                    </div>
                    <div class="form-group">
                      <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="activity_area">
                      <label class="form-check-label pl-5 pr-4" >No</label>
                    </div>
                  </div>
                </div>
<!-- anotherKid -->
                <div class="col-md-6 type-data form-check  w-100 mt-3">
                  <label class="customLabel">Any plan for another child? If yes, should we consider the room for another kid</label>
                  <div class="d-flex">
                    <div class="form-group">
                      <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="plan_another_child">
                      <label class="form-check-label pl-5 pr-4" >Yes</label>
                    </div>
                    <div class="form-group">
                      <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="plan_another_child">
                      <label class="form-check-label pl-5 pr-4" >No</label>
                    </div>
                  </div>
                </div>

                <div class="header col-md-12  mt-2">Budget for the room</div>
<!-- core_material -->
                <div class="col-md-6 d-flex flex-column mt-4">
                  <label class="customLabel">Core material</label>
                  <div class="">
                    <div class="form-group">
                      <input class="form-check-input ml-3 " type="radio" formControlName="core_material_kids"  value="MDF" >
                      <label class="form-check-label pl-5 pr-4 " >MDF</label>
                    </div>
                    <div class="form-group">
                      <input class="form-check-input ml-3 " type="radio" formControlName="core_material_kids" value="HDHMR" >
                      <label class="form-check-label pl-5 pr-4" >HDHMR</label>
                    </div>
                    <div class="form-group">
                      <input class="form-check-input ml-3 " type="radio" formControlName="core_material_kids"  value="Ply" >
                      <label class="form-check-label pl-5 pr-4 ">Ply</label>
                    </div>
                  </div>
                </div> 
<!-- finish_material -->
                <div class="col-md-6 type-data form-check  w-100 mt-3">
                  <label class="customLabel">Finish Material</label>
                  <div class="">
                    <div class="form-group">
                      <input type="radio" class="form-check-input ml-3"  value="Entry_Level_Laminates" formControlName="finish_material_kids">
                      <label class="form-check-label pl-5 pr-4" >Entry Level Laminates </label>
                    </div>
                    <div class="form-group">
                      <input type="radio" class="form-check-input ml-3"  value="Premium_Range" formControlName="finish_material_kids">
                      <label class="form-check-label pl-5 pr-4" >Premium Range</label>
                    </div>
                    <div class="form-group">
                      <input type="radio" class="form-check-input ml-3"  value="PU" formControlName="finish_material_kids">
                      <label class="form-check-label pl-5 pr-4" >PU</label>
                    </div>
                  </div>
                </div>
<!-- finish_choice -->
                <div class="col-md-6 mt-4">
                  <label class="customLabel">Estimate as per material and finish choice </label>
                  <input type="text" class="form-control" formControlName="estimate_kids" placeholder="">
                </div>

                <div class="header col-md-12  mt-2">Services</div>
<!-- servicesRequire -->
              <div class="col-md-6 d-flex flex-column mt-3">
                <label class="customLabel">What services would you require in this room</label>
                <label class="ml-2 d-flex" formArrayName="services_require_kids" *ngFor="let order of services_require_kids; let i = index" >
                  <input type="checkbox" [checked]="this.serviceKids.includes(order.name)" [value]="order.name" (change)="onCheckboxChange($event,'services_require_kids')">
                  &nbsp; {{order.id}} 
                </label>
              </div>

              <div class="col-md-12  d-flex justify-content-between m-0 px-5 pt-3">
                <button class="save btn btn-pink" (click)="saveasdraft()">Save as draft</button>
                <button class="next btn btn-pink" (click)="gotonext()">Next</button>
              </div>
          
          </div>
 <!-- living_room -->        
          <div class="row" *ngIf="this.selectedtab=='living_room'">
            <div class="header col-md-12  my-2  d-flex justify-content-between">
              <span>Requirements for Living Bedroom - Shoe Cabinet</span>
              <!-- <span> <i class="fas fa-edit"></i></span> -->
            </div>
            <!-- <div  formGroupName="Living_Room" > -->
              <!-- <div class="header col-md-12">Shoe Cabinet</div> -->
<!-- shoeCabinet -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Do u require a shoe cabinet</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="shoe_cabinet">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="shoe_cabinet">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- shoeChangingStool -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Do you need shoe changing stool for kids or aged parents</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="shoe_stool">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="shoe_stool">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>

              <div class="header col-md-12 mt-2">Partition</div>
<!-- partitionEntranceLiving -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Do you need a partition to divide entrance area and living area</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="partition_area_bet_enterance_liv_area">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="partition_area_bet_enterance_liv_area">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- CabinetCounterPartition -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Do you want the partition can combine with shoe cabinet or bar counter.</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="combine_shoecabinet">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="combine_shoecabinet">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>

              <div class="header col-md-12 mt-2">Sofa</div>
<!-- PositionOfSofa -->
              <div class="col-md-6 mt-4">
                <label class="customLabel">Position of Sofa</label>
                <input type="text" class="form-control" formControlName="sofa_position" placeholder="">
              </div>
<!-- ShapeOfSofa -->
              <div class="col-md-6 mt-4">
                <label class="customLabel">How big is your sofa, or what kind of shape do you like?  I/L shape </label>
                <input type="text" class="form-control" formControlName="sofa_shape" placeholder="">
              </div>

              <div class="header col-md-12  mt-2">TV Cabinet</div>
<!-- TVCabinet -->
              <div class="col-md-6 mt-4">
                <label class="customLabel">How big is your TV </label>
                <input type="text" class="form-control" formControlName="tv_size" placeholder="">
              </div>
<!-- SimpleStorageTvCabinet -->
              <div class="col-md-6 mt-4">
                <label class="customLabel">Do you like a simple TV cabinet or need some/a lot of storage space</label>
                <input type="text" class="form-control" formControlName="tv_cabinet" placeholder="">
              </div>
<!-- multimediaAppliances -->
              <div class="col-md-6 mt-4">
                <label class="customLabel">Do you have DVD, game machine, xbox or other multimedia appliances </label>
                <input type="text" class="form-control" formControlName="multimedia_appliances" placeholder="">
              </div>
<!-- OpenOrGlassDoors -->
              <div class="col-md-6 mt-4">
                <label class="customLabel">Do you need some open racks or glass doors for TV cabinet</label>
                <input type="text" class="form-control" formControlName="open_racks" placeholder="">
              </div>

              <div class="header col-md-12  mt-2">Dinning Room</div>
<!-- TableTop -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel"> What material you would like in the table top</label>
                <div class="">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Marble" formControlName="dining_table_top">
                    <label class="form-check-label pl-5 pr-4" >Marble</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Wood" formControlName="dining_table_top">
                    <label class="form-check-label pl-5 pr-4" >Wood</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Glass" formControlName="dining_table_top">
                    <label class="form-check-label pl-5 pr-4" >Glass</label>
                  </div>
                </div>
              </div>
<!-- DinningTable -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">How big is the dining table? How many dining chairs</label>
                <div class="">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="4 seater" formControlName="dining_size">
                    <label class="form-check-label pl-5 pr-4" >4 seater</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="6 seater" formControlName="dining_size">
                    <label class="form-check-label pl-5 pr-4" >6 seater</label>
                  </div>
                    <div class="form-group">
                      <input type="radio" class="form-check-input ml-3"  value="8 seater" formControlName="dining_size">
                      <label class="form-check-label pl-5 pr-4" >8 seater</label>
                    </div>
                    <div class="form-group">
                      <input type="radio" class="form-check-input ml-3"  value="with bench" formControlName="dining_size">
                      <label class="form-check-label pl-5 pr-4" >with bench</label>
                    </div>
                </div> 
              </div>    
<!-- CrockeryUnit -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Do you need a crockery unit</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="crockery_unit">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="crockery_unit">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div> 

              <div class="header col-md-12  mt-2">Budget</div>
<!-- core_material -->
                <div class="col-md-6 d-flex flex-column mt-4">
                  <label class="customLabel">Core material</label>
                  <div class="">
                    <div class="form-group">
                      <input class="form-check-input ml-3 " type="radio" formControlName="core_material_living"  value="MDF" >
                      <label class="form-check-label pl-5 pr-4 " >MDF</label>
                    </div>
                    <div class="form-group">
                      <input class="form-check-input ml-3 " type="radio" formControlName="core_material_living" value="HDHMR" >
                      <label class="form-check-label pl-5 pr-4" >HDHMR</label>
                    </div>
                    <div class="form-group">
                      <input class="form-check-input ml-3 " type="radio" formControlName="core_material_living"  value="Ply" >
                      <label class="form-check-label pl-5 pr-4 ">Ply</label>
                    </div>
                  </div>
                </div> 
<!-- finish_material -->
                <div class="col-md-6 type-data form-check  w-100 mt-3">
                  <label class="customLabel">Finish Material</label>
                  <div class="">
                    <div class="form-group">
                      <input type="radio" class="form-check-input ml-3"  value="Standard Laminate" formControlName="finish_material_living">
                      <label class="form-check-label pl-5 pr-4" >Standard Laminate </label>
                    </div>
                    <div class="form-group">
                      <input type="radio" class="form-check-input ml-3"  value="Premium Laminate" formControlName="finish_material_living">
                      <label class="form-check-label pl-5 pr-4" >Premium Laminate</label>
                    </div>
                  </div>
                </div>
<!-- finish_choice -->
                <div class="col-md-6 mt-4">
                  <label class="customLabel">Estimate as per material and finish choice </label>
                  <input type="text" class="form-control" formControlName="estimate_living" placeholder="">
                </div>

                <div class="header col-md-12  mt-2">Services</div>
<!-- servicesRequire -->
              <div class="col-md-6 d-flex flex-column mt-3">
                <label class="customLabel">What services would you require in this room</label>
                <label class="ml-2 d-flex" formArrayName="services_require_living" *ngFor="let order of services_require_living; let i = index" >
                  <input type="checkbox" [checked]="this.serviceLiving.includes(order.name)" [value]="order.name" (change)="onCheckboxChange($event,'services_require_living')">
                  &nbsp; {{order.id}} 
                </label>
              </div>
                
<!-- serviceDescription -->
                <div class="col-md-6 mt-4">
                  <label class="customLabel">Services Description</label>
                  <input type="text" class="form-control " formControlName="services_description" placeholder="">
                </div>        

              <div class="col-md-12  d-flex justify-content-between m-0 px-5 pt-3">
                <button class="save btn btn-pink" (click)="saveasdraft()">Save as draft</button>
                <button class="next btn btn-pink" (click)="gotonext()">Next</button>
              </div>
          
          </div>  
 <!-- kitchen -->
          <div class="row" *ngIf="this.selectedtab=='kitchen'">

            <div class="header col-md-12  my-2  d-flex justify-content-between">
              <span>Requirements for Kitchten</span>
              <!-- <span> <i class="fas fa-edit"></i></span> -->
            </div>
            <!-- <div  formGroupName="Kitchen" > -->
        
<!-- typeOfKitchen -->
              <div class="col-md-6 type-data form-check w-100 mt-3">
                <label class="customLabel">What is the type of kitchen</label>
                <div class="">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Modular" formControlName="kitchen_type">
                    <label class="form-check-label pl-5 pr-4" >Modular</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Semi Modular" formControlName="kitchen_type">
                    <label class="form-check-label pl-5 pr-4" >Semi Modular</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="New Civil" formControlName="kitchen_type">
                    <label class="form-check-label pl-5 pr-4" >New Civil</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Existing Civil" formControlName="kitchen_type">
                    <label class="form-check-label pl-5 pr-4" >Existing Civil</label>
                  </div>
                </div>
              </div>
<!-- chef -->
              <div class="col-md-6 mt-4">
                <label class="customLabel">Who is the chef? An personal habits</label>
                <input type="text" class="form-control " formControlName="chef" placeholder="">
              </div>
<!-- shapeOfKitchen -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">What kind of shape would you prefer your kitchen</label>
                <div class="">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="I Shaped" formControlName="kitchen_shape">
                    <label class="form-check-label pl-5 pr-4" >I Shaped</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="L Shaped" formControlName="kitchen_shape">
                    <label class="form-check-label pl-5 pr-4" >L Shaped</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="U Shaped" formControlName="kitchen_shape">
                    <label class="form-check-label pl-5 pr-4" >U Shaped</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Parallel" formControlName="kitchen_shape">
                    <label class="form-check-label pl-5 pr-4" >Parallel</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="With Island" formControlName="kitchen_shape">
                    <label class="form-check-label pl-5 pr-4" >With Island</label>
                  </div>
                </div>
              </div>
<!-- fridgeSize -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Do you need to put fridge in this kitchen? What size would you prefer</label>
                <div class="">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Single Door" formControlName="fridge_size">
                    <label class="form-check-label pl-5 pr-4" >Single Door </label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Double Door" formControlName="fridge_size">
                    <label class="form-check-label pl-5 pr-4" >Double Door</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Side to side " formControlName="fridge_size">
                    <label class="form-check-label pl-5 pr-4" >Side to side ( As as per location and High end - 1200 sq ft and above)</label>
                  </div>
                </div>
              </div>
<!-- sinkType -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">What sink type would you prefer</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Single Bowl" formControlName="sink_type">
                    <label class="form-check-label pl-5 pr-4" >Single Bowl </label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Single with Drain" formControlName="sink_type">
                    <label class="form-check-label pl-5 pr-4" >Single with Drain</label>
                  </div>
                </div>
              </div>
<!-- ConnectionType -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Connection Type</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Gas Pipeline" formControlName="gas_connection_type">
                    <label class="form-check-label pl-5 pr-4" >Gas Pipeline</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Cylinder" formControlName="gas_connection_type">
                    <label class="form-check-label pl-5 pr-4" >Cylinder</label>
                  </div>
                </div>
              </div>
<!-- HobRequired -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Hob Required</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="hob_require">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="hob_require">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- chimneyRequired -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Chimney Required</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="chimney_require">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="chimney_require">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- InductionOrCooktop -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Induction / Cooktop Required</label>
                <div class="">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Induction" formControlName="induction_cooktop">
                    <label class="form-check-label pl-5 pr-4" >Induction</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Cooktop" formControlName="induction_cooktop">
                    <label class="form-check-label pl-5 pr-4" >Cooktop</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Both" formControlName="induction_cooktop">
                    <label class="form-check-label pl-5 pr-4" >Both</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="None" formControlName="induction_cooktop">
                    <label class="form-check-label pl-5 pr-4" >None</label>
                  </div>
                </div>
              </div>
<!-- OtherAppliance -->
              <div class="col-md-6 d-flex flex-column mt-3">
                <label class="customLabel">Other appliances in kitchen</label>
                <label class="ml-2 d-flex" formArrayName="other_appliances" *ngFor="let order of other_appliances; let i = index" >
                  <input type="checkbox" [checked]="this.otherApplience.includes(order.name)" [value]="order.name"  (change)="onCheckboxChange($event,'other_appliances')" >
                  &nbsp; {{order.id}} 
                </label>
              </div>
<!-- Additionlalsocket -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Additional sockets required</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="socked_require">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="socked_require">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- waterPurifier -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Do you wish to cover the water purifier</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="water_purifier">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="water_purifier">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- grainsStorage -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">How do you store your grains</label>
                <div class="">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Monthly" formControlName="grains_store">
                    <label class="form-check-label pl-5 pr-4" >Monthly </label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Quarterly" formControlName="grains_store">
                    <label class="form-check-label pl-5 pr-4" >Quarterly</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Yearly" formControlName="grains_store">
                    <label class="form-check-label pl-5 pr-4" >Yearly</label>
                  </div>
                </div>
              </div>
<!-- typeOfunits -->
              <div class="col-md-6 d-flex flex-column mt-3">
                <label class="customLabel">What type of units are needed in the kitchen</label>
                <label class="ml-2 d-flex" formArrayName="units_type" *ngFor="let order of units_type; let i = index" (change)="onCheckboxChange($event,'units_type')">
                  <input type="checkbox" [checked]="this.units.includes(order.name)" [value]="order.name" >
                  &nbsp; {{order.id}} 
                </label>
              </div>         
<!-- wickerBasket -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Will you consider to put wicker basket in the cabinet</label>
                <div class="">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="1 basket" formControlName="wicker_basket">
                    <label class="form-check-label pl-5 pr-4" >1 basket</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="2 basket" formControlName="wicker_basket">
                    <label class="form-check-label pl-5 pr-4" >2 baskets</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="None" formControlName="wicker_basket">
                    <label class="form-check-label pl-5 pr-4" >None</label>
                  </div>
                </div>
              </div>
<!-- washingMeachine -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Will you consider putting the washing machine near kitchen</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="washing_machine_near_kitchen">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="washing_machine_near_kitchen">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- designCabinet -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Do you plan to design island cabinet</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="island_cabinet">
                    <label class="form-check-label pl-5 pr-4" >Yes </label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="island_cabinet">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- CounterTop -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Is the builder providing the counter top</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="counter_top">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false" formControlName="counter_top">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- TypeOfCounterTop -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">If not, what counter top would you prefer</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Granite" formControlName="prefer_counter_top">
                    <label class="form-check-label pl-5 pr-4" >Granite </label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Quartz" formControlName="prefer_counter_top">
                    <label class="form-check-label pl-5 pr-4" >Quartz</label>
                  </div>
                </div>
              </div>
<!-- Mandir -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">Would you place a mandir in the kitchen</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="true" formControlName="mandir">
                    <label class="form-check-label pl-5 pr-4" >Yes</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  [value]="false " formControlName="mandir">
                    <label class="form-check-label pl-5 pr-4" >No</label>
                  </div>
                </div>
              </div>
<!-- LoftType -->
              <div class="col-md-6 type-data form-check  w-100 mt-3">
                <label class="customLabel">What kind of loft would you need</label>
                <div class="d-flex">
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Loft" formControlName="loft">
                    <label class="form-check-label pl-5 pr-4" > Loft</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" class="form-check-input ml-3"  value="Loft Frame" formControlName="loft">
                    <label class="form-check-label pl-5 pr-4" >Loft Frame</label>
                  </div>
                </div>
              </div>
<!-- shadeForKitchen -->
              <div class="col-md-6 mt-4">
                <label class="customLabel">What shade would you prefer for the kitchen</label>
                <input type="text" class="form-control " formControlName="shade" placeholder="">
              </div>

              <div class="header col-md-12  mt-2">Budget</div>
<!-- core_material -->
                <div class="col-md-6 d-flex flex-column mt-4">
                  <label class="customLabel">Core material</label>
                  <div class="">
                    <div class="form-group">
                      <input class="form-check-input ml-3 " type="radio" formControlName="core_material_kitchen"  value="MDF" >
                      <label class="form-check-label pl-5 pr-4 " >MDF</label>
                    </div>
                    <div class="form-group">
                      <input class="form-check-input ml-3 " type="radio" formControlName="core_material_kitchen" value="HDHMR" >
                      <label class="form-check-label pl-5 pr-4" >HDHMR</label>
                    </div>
                    <div class="form-group">
                      <input class="form-check-input ml-3 " type="radio" formControlName="core_material_kitchen"  value="Ply" >
                      <label class="form-check-label pl-5 pr-4 ">Ply</label>
                    </div>
                  </div>
                </div> 
<!-- finish_material -->
                <div class="col-md-6 type-data form-check  w-100 mt-3">
                  <label class="customLabel">Finish Material</label>
                  <div class="">
                    <div class="form-group">
                      <input type="radio" class="form-check-input ml-3"  value="Standard Laminate" formControlName="finish_material_kitchen">
                      <label class="form-check-label pl-5 pr-4" >Standard Laminate </label>
                    </div>
                    <div class="form-group">
                      <input type="radio" class="form-check-input ml-3"  value="Premium Laminate" formControlName="finish_material_kitchen">
                      <label class="form-check-label pl-5 pr-4" >Premium Laminate</label>
                    </div>
                  </div>
                </div>
<!-- finish_choice -->
                <div class="col-md-6 mt-4">
                  <label class="customLabel">Estimate as per material and finish choice</label>
                  <input type="text" class="form-control " formControlName="estimate_kitchen" placeholder="">
                </div>

                <div class="header col-md-12 mt-2">Services</div>
<!-- servicesRequire -->
              <div class="col-md-6 d-flex flex-column mt-3">
                <label class="customLabel">What services would you require in this room</label>
                <label class="ml-2 d-flex" formArrayName="services_require_kitchen" *ngFor="let order of services_require; let i = index" >
                  <input type="checkbox" [checked]="this.serviceKitchen.includes(order.name)" [value]="order.name" (change)="onCheckboxChange($event,'services_require_kitchen')">
                  &nbsp; {{order.id}} 
                </label>
              </div>
               

              <div class="col-md-12  d-flex justify-content-between m-0 px-5 pt-3">
                <button class="save btn btn-pink" (click)="saveasdraft()">Save as draft</button>
                <button *ngIf="this.submitbutton" class="next btn btn-pink" (click)="customerDemandFormSubmit()">Submit</button>
                <button *ngIf="!(this.submitbutton)" class="next btn btn-pink" (click)="customerDemandFormSubmit()">Update</button>
              </div>
          
          </div>

          <div class="rk-ui-notification" *ngIf="successalert">
            <span id="notificationMessageText">{{successMessage}}</span>
            <a class="close rk-linknotification" (click)="successalert=false">×</a>
          </div>
          <div class="rk-ui-notification err" *ngIf="erroralert">
            <span id="notificationMessageText">{{errorMessage}}</span>
            <a class="close rk-linknotification" (click)="erroralert=false">×</a>
          </div>
          
        </form>
      </div>
    

</div>


// WEBPACK FOOTER //
// ./src/app/platform/lead/customer-demand/customer-demand.component.html